import React from 'react';


export const MobileFilter = () => {
    const [isMobileFilterOpen, setIsMobileFilterOpen] = React.useState(false);

    const toggleMobileFilter = (e:any) => {
        e.preventDefault();
        setIsMobileFilterOpen(!isMobileFilterOpen);
    }

    return(
        <div className="primary-border-bottom claims-filter-mobile">
  <button
    className="filter-header cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
    data-test="filter-mobile-header-button"
    type="button"
    onClick={toggleMobileFilter}
    aria-expanded="true"
    aria-labelledby="Claims Filters"
  >
    Filters
  </button>
  <div
    className="cont_-hTprGpvLsxeBIyLefTJ7 collapsible batch-filter__select-group"
    role="region"
    data-test="filter-mobile-option-group"
    aria-hidden="false"
    style={isMobileFilterOpen?{height: 'auto', display:'block'}:{height: 0, overflow: "hidden", display: "none"}}
  >
    <div className="card">
      <button
        className="claims-filter-header-btn cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
        type="button"
      >
        <header
          className="card-header claims-filter-mobile__card-header"
          data-test="Member-filter-header"
        >
          <div>
            <h2 className="cont_-SFHQaE2KJVgFh593fnTV card-headline zeta fw-600">
              Member
            </h2>
            <span className="cont_-wIRMQjq_t9WD_r5T8FRs card__subheadline">
              All
            </span>
          </div>
          <svg
            className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-eruDGVsNkUHIZvl3ak2G svg"
            data-test="eot-accordion-caret-icon"
            aria-label="Member filter down caret"
            role="img"
            aria-hidden="true"
          >
            <title data-test="eot-accordion-caret-icon-title">
              Member filter down caret
            </title>
            <use xlinkHref="#anatomy-caret-down" />
          </svg>
        </header>
      </button>
    </div>
    <div
      className="cont_-hTprGpvLsxeBIyLefTJ7 collapsible batch-filter__select-group"
      role="region"
      data-test="batch-filter-select-group"
      hidden={false}
      aria-hidden="true"
      style={{ height: 0, overflow: "hidden", display: "none" }}
    >
      <div className="card-body claims-filter-mobile-options">
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id="All"
            type="radio"
            name="Member"
            aria-labelledby=":rmj:"
            defaultValue="All"
            defaultChecked={false}
          />
          <label
            id=":rmj:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor="All"
          >
            All
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id="Ziping (Self)"
            type="radio"
            name="Member"
            aria-labelledby=":rml:"
            defaultValue="Ziping (Self)"
          />
          <label
            id=":rml:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor="Ziping (Self)"
          >
            Ziping (Self)
          </label>
        </div>
      </div>
    </div>
    <div className="card">
      <button
        className="claims-filter-header-btn cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
        type="button"
      >
        <header
          className="card-header claims-filter-mobile__card-header"
          data-test="ServiceType-filter-header"
        >
          <div>
            <h2 className="cont_-SFHQaE2KJVgFh593fnTV card-headline zeta fw-600">
              Claim Type
            </h2>
            <span className="cont_-wIRMQjq_t9WD_r5T8FRs card__subheadline">
              All
            </span>
          </div>
          <svg
            className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-eruDGVsNkUHIZvl3ak2G svg"
            data-test="eot-accordion-caret-icon"
            aria-label="ServiceType filter down caret"
            role="img"
            aria-hidden="true"
          >
            <title data-test="eot-accordion-caret-icon-title">
              ServiceType filter down caret
            </title>
            <use xlinkHref="#anatomy-caret-down" />
          </svg>
        </header>
      </button>
    </div>
    <div
      className="cont_-hTprGpvLsxeBIyLefTJ7 collapsible batch-filter__select-group"
      role="region"
      data-test="batch-filter-select-group"
      hidden={false}
      aria-hidden="true"
      style={{ height: 0, overflow: "hidden", display: "none" }}
    >
      <div className="card-body claims-filter-mobile-options">
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":rmm:"
            type="radio"
            name="ServiceType"
            data-test="ServiceType-radio-input"
            aria-labelledby=":rmn:"
            defaultValue="All"
            defaultChecked={false}
          />
          <label
            id=":rmn:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":rmm:"
            data-test="ServiceType-radio"
          >
            All
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":rmo:"
            type="radio"
            name="ServiceType"
            data-test="ServiceType-radio-input"
            aria-labelledby=":rmp:"
            defaultValue="Medical"
          />
          <label
            id=":rmp:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":rmo:"
            data-test="ServiceType-radio"
          >
            Medical
          </label>
        </div>
      </div>
    </div>
    <div className="card">
      <button
        className="claims-filter-header-btn cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
        type="button"
      >
        <header
          className="card-header claims-filter-mobile__card-header"
          data-test="DateOfService-filter-header"
        >
          <div>
            <h2 className="cont_-SFHQaE2KJVgFh593fnTV card-headline zeta fw-600">
              Date Range
            </h2>
            <span className="cont_-wIRMQjq_t9WD_r5T8FRs card__subheadline">
              All (Last 2 years)
            </span>
          </div>
          <svg
            className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-eruDGVsNkUHIZvl3ak2G svg"
            data-test="eot-accordion-caret-icon"
            aria-label="DateOfService filter down caret"
            role="img"
            aria-hidden="true"
          >
            <title data-test="eot-accordion-caret-icon-title">
              DateOfService filter down caret
            </title>
            <use xlinkHref="#anatomy-caret-down" />
          </svg>
        </header>
      </button>
    </div>
    <div
      className="cont_-hTprGpvLsxeBIyLefTJ7 collapsible batch-filter__select-group"
      role="region"
      data-test="batch-filter-select-group"
      hidden={false}
      aria-hidden="true"
      style={{ height: 0, overflow: "hidden", display: "none" }}
    >
      <div className="card-body claims-filter-mobile-options">
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id="DateOfService-730"
            type="radio"
            name="DateOfService"
            data-test="DateOfService-radio-input"
            aria-labelledby=":rmr:"
            defaultValue="DateOfService-730"
            defaultChecked={false}
          />
          <label
            id=":rmr:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor="DateOfService-730"
            data-test="DateOfService-radio"
          >
            All (Last 2 years)
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id="DateOfService-156"
            type="radio"
            name="DateOfService"
            data-test="DateOfService-radio-input"
            aria-labelledby=":rmt:"
            defaultValue="DateOfService-156"
          />
          <label
            id=":rmt:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor="DateOfService-156"
            data-test="DateOfService-radio"
          >
            Year to date
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id="DateOfService-365"
            type="radio"
            name="DateOfService"
            data-test="DateOfService-radio-input"
            aria-labelledby=":rmv:"
            defaultValue="DateOfService-365"
          />
          <label
            id=":rmv:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor="DateOfService-365"
            data-test="DateOfService-radio"
          >
            Last 365 days
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id="DateOfService-180"
            type="radio"
            name="DateOfService"
            data-test="DateOfService-radio-input"
            aria-labelledby=":rn1:"
            defaultValue="DateOfService-180"
          />
          <label
            id=":rn1:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor="DateOfService-180"
            data-test="DateOfService-radio"
          >
            Last 180 days
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id="DateOfService-90"
            type="radio"
            name="DateOfService"
            data-test="DateOfService-radio-input"
            aria-labelledby=":rn3:"
            defaultValue="DateOfService-90"
          />
          <label
            id=":rn3:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor="DateOfService-90"
            data-test="DateOfService-radio"
          >
            Last 90 days
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id="DateOfService-30"
            type="radio"
            name="DateOfService"
            data-test="DateOfService-radio-input"
            aria-labelledby=":rn5:"
            defaultValue="DateOfService-30"
          />
          <label
            id=":rn5:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor="DateOfService-30"
            data-test="DateOfService-radio"
          >
            Last 30 days
          </label>
        </div>
      </div>
    </div>
    <div className="card">
      <button
        className="claims-filter-header-btn cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
        type="button"
      >
        <header
          className="card-header claims-filter-mobile__card-header"
          data-test="Description-filter-header"
        >
          <div>
            <h2 className="cont_-SFHQaE2KJVgFh593fnTV card-headline zeta fw-600">
              Provider, Facility or Rx
            </h2>
            <span className="cont_-wIRMQjq_t9WD_r5T8FRs card__subheadline">
              All
            </span>
          </div>
          <svg
            className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-eruDGVsNkUHIZvl3ak2G svg"
            data-test="eot-accordion-caret-icon"
            aria-label="Description filter down caret"
            role="img"
            aria-hidden="true"
          >
            <title data-test="eot-accordion-caret-icon-title">
              Description filter down caret
            </title>
            <use xlinkHref="#anatomy-caret-down" />
          </svg>
        </header>
      </button>
    </div>
    <div
      className="cont_-hTprGpvLsxeBIyLefTJ7 collapsible batch-filter__select-group"
      role="region"
      data-test="batch-filter-select-group"
      hidden={false}
      aria-hidden="true"
      style={{ height: 0, overflow: "hidden", display: "none" }}
    >
      <div className="card-body claims-filter-mobile-options">
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":rn6:"
            type="radio"
            name="Description"
            data-test="Description-radio-input"
            aria-labelledby=":rn7:"
            defaultValue="All"
            defaultChecked={false}
          />
          <label
            id=":rn7:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":rn6:"
            data-test="Description-radio"
          >
            All
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":rn8:"
            type="radio"
            name="Description"
            data-test="Description-radio-input"
            aria-labelledby=":rn9:"
            defaultValue="Abiola Oyemade"
          />
          <label
            id=":rn9:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":rn8:"
            data-test="Description-radio"
          >
            Abiola Oyemade
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":rna:"
            type="radio"
            name="Description"
            data-test="Description-radio-input"
            aria-labelledby=":rnb:"
            defaultValue="James Kingsley"
          />
          <label
            id=":rnb:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":rna:"
            data-test="Description-radio"
          >
            James Kingsley
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":rnc:"
            type="radio"
            name="Description"
            data-test="Description-radio-input"
            aria-labelledby=":rnd:"
            defaultValue="Knoelle Park"
          />
          <label
            id=":rnd:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":rnc:"
            data-test="Description-radio"
          >
            Knoelle Park
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":rne:"
            type="radio"
            name="Description"
            data-test="Description-radio-input"
            aria-labelledby=":rnf:"
            defaultValue="LabCorp"
          />
          <label
            id=":rnf:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":rne:"
            data-test="Description-radio"
          >
            LabCorp
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":rng:"
            type="radio"
            name="Description"
            data-test="Description-radio-input"
            aria-labelledby=":rnh:"
            defaultValue="Mohamed Ahmed"
          />
          <label
            id=":rnh:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":rng:"
            data-test="Description-radio"
          >
            Mohamed Ahmed
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":rni:"
            type="radio"
            name="Description"
            data-test="Description-radio-input"
            aria-labelledby=":rnj:"
            defaultValue="Quest Diagnostics"
          />
          <label
            id=":rnj:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":rni:"
            data-test="Description-radio"
          >
            Quest Diagnostics
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":rnk:"
            type="radio"
            name="Description"
            data-test="Description-radio-input"
            aria-labelledby=":rnl:"
            defaultValue="Rachel Gratz"
          />
          <label
            id=":rnl:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":rnk:"
            data-test="Description-radio"
          >
            Rachel Gratz
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":rnm:"
            type="radio"
            name="Description"
            data-test="Description-radio-input"
            aria-labelledby=":rnn:"
            defaultValue="Rebecca Maxwell"
          />
          <label
            id=":rnn:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":rnm:"
            data-test="Description-radio"
          >
            Rebecca Maxwell
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":rno:"
            type="radio"
            name="Description"
            data-test="Description-radio-input"
            aria-labelledby=":rnp:"
            defaultValue="Scott Lisse"
          />
          <label
            id=":rnp:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":rno:"
            data-test="Description-radio"
          >
            Scott Lisse
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":rnq:"
            type="radio"
            name="Description"
            data-test="Description-radio-input"
            aria-labelledby=":rnr:"
            defaultValue="Selma Raheem"
          />
          <label
            id=":rnr:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":rnq:"
            data-test="Description-radio"
          >
            Selma Raheem
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":rns:"
            type="radio"
            name="Description"
            data-test="Description-radio-input"
            aria-labelledby=":rnt:"
            defaultValue="Shamima Khan"
          />
          <label
            id=":rnt:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":rns:"
            data-test="Description-radio"
          >
            Shamima Khan
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":rnu:"
            type="radio"
            name="Description"
            data-test="Description-radio-input"
            aria-labelledby=":rnv:"
            defaultValue="Shelly Thomas"
          />
          <label
            id=":rnv:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":rnu:"
            data-test="Description-radio"
          >
            Shelly Thomas
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":ro0:"
            type="radio"
            name="Description"
            data-test="Description-radio-input"
            aria-labelledby=":ro1:"
            defaultValue="Sobia Moghis"
          />
          <label
            id=":ro1:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":ro0:"
            data-test="Description-radio"
          >
            Sobia Moghis
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":ro2:"
            type="radio"
            name="Description"
            data-test="Description-radio-input"
            aria-labelledby=":ro3:"
            defaultValue="The Kingsley Clinic"
          />
          <label
            id=":ro3:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":ro2:"
            data-test="Description-radio"
          >
            The Kingsley Clinic
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":ro4:"
            type="radio"
            name="Description"
            data-test="Description-radio-input"
            aria-labelledby=":ro5:"
            defaultValue="The Kingsley Clinic of New Mexico LLC"
          />
          <label
            id=":ro5:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":ro4:"
            data-test="Description-radio"
          >
            The Kingsley Clinic of New Mexico LLC
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":ro6:"
            type="radio"
            name="Description"
            data-test="Description-radio-input"
            aria-labelledby=":ro7:"
            defaultValue="Vy Nguyen"
          />
          <label
            id=":ro7:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":ro6:"
            data-test="Description-radio"
          >
            Vy Nguyen
          </label>
        </div>
      </div>
    </div>
    <div className="card">
      <button
        className="claims-filter-header-btn cont_-JEfBnG27qO4IIuOLki4g cont_-qH3eCqtmzdVgILlwuay2"
        type="button"
      >
        <header
          className="card-header claims-filter-mobile__card-header"
          data-test="ClaimStatus-filter-header"
        >
          <div>
            <h2 className="cont_-SFHQaE2KJVgFh593fnTV card-headline zeta fw-600">
              Claim Status
            </h2>
            <span className="cont_-wIRMQjq_t9WD_r5T8FRs card__subheadline">
              All
            </span>
          </div>
          <svg
            className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-eruDGVsNkUHIZvl3ak2G svg"
            data-test="eot-accordion-caret-icon"
            aria-label="ClaimStatus filter down caret"
            role="img"
            aria-hidden="true"
          >
            <title data-test="eot-accordion-caret-icon-title">
              ClaimStatus filter down caret
            </title>
            <use xlinkHref="#anatomy-caret-down" />
          </svg>
        </header>
      </button>
    </div>
    <div
      className="cont_-hTprGpvLsxeBIyLefTJ7 collapsible batch-filter__select-group"
      role="region"
      data-test="batch-filter-select-group"
      hidden={false}
      aria-hidden="true"
      style={{ height: 0, overflow: "hidden", display: "none" }}
    >
      <div className="card-body claims-filter-mobile-options">
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":ro8:"
            type="radio"
            name="ClaimStatus"
            data-test="ClaimStatus-radio-input"
            aria-labelledby=":ro9:"
            defaultValue="All"
            defaultChecked={false}
          />
          <label
            id=":ro9:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":ro8:"
            data-test="ClaimStatus-radio"
          >
            All
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":roa:"
            type="radio"
            name="ClaimStatus"
            data-test="ClaimStatus-radio-input"
            aria-labelledby=":rob:"
            defaultValue="Completed"
          />
          <label
            id=":rob:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":roa:"
            data-test="ClaimStatus-radio"
          >
            Processed
          </label>
        </div>
        <div className="cont_-TM9asgUYiLysKrhGNapw">
          <input
            id=":roc:"
            type="radio"
            name="ClaimStatus"
            data-test="ClaimStatus-radio-input"
            aria-labelledby=":rod:"
            defaultValue="Denied"
          />
          <label
            id=":rod:"
            className="cont_-G207zBJdUZqOeGR2Eajq"
            htmlFor=":roc:"
            data-test="ClaimStatus-radio"
          >
            Denied
          </label>
        </div>
      </div>
    </div>
    <div className="batch-filter__actions">
      <button
        className="batch-filter__button batch-filter__reset cont_-JEfBnG27qO4IIuOLki4g cont_-K45xVhoe79nwsN7am1WQ"
        data-test="batch-filter-reset-button"
        name="Reset Filters"
        type="button"
      >
        Reset Filters
      </button>
      <button
        className="batch-filter__button batch-filter__cancel cont_-JEfBnG27qO4IIuOLki4g cont_-K45xVhoe79nwsN7am1WQ"
        data-test="batch-filter-cancel-button"
        name="Cancel"
        type="button"
      >
        Cancel
      </button>
      <button
        className="batch-filter__button batch-filter__apply cont_-JEfBnG27qO4IIuOLki4g cont_-ohFbtuViT2xHgVSbaMZR"
        data-test="batch-filter-apply-button"
        name="Apply"
        type="button"
      >
        Apply
      </button>
    </div>
  </div>
</div>

    )
}

export const Filter = () => {

    return(<>
        <h2
        className="cont_-SFHQaE2KJVgFh593fnTV claims-filter__title"
        data-test="claims-sidebar-title"
      >
        Filters
      </h2>
      <article className="card claims-filter" data-test="claims-filter">
        <div className="cont_-tARug9kSRZL7rroO576n container instant-filter">
          <div
            id="Member-select"
            className="cont_-N9KR1n0RF2JkoKJLHIHS select-v2 cont_-YGjIz1Nflfo8gMoF9yFL instant-filter__select select-v2--closed select-v2--enabled cont_-DcdX5FlnSEm2FkuYTXx0 select-v2--has-border cont_-GAxItQ2D3EspEN8bWAJn select-v2--use-native-select-mobile"
            data-test="member-select"
          >
            <label
              tabIndex={-1}
              id="downshift-0-label"
              className="cont_-W4MAs4fmY6dxuoeYyFlf form-label cont_-IMXkw5CLTbb4noFSIyeA select-v2__label"
              data-test="member-select-label"
              htmlFor="downshift-0-toggle-button"
            >
              Member
            </label>
            <button
              className="cont_-_O34cw7eYfQ1NOc6rYLM select-v2__value black fw-normal select-v2__value--closed cont_-yMA3kYVl9ioy584Ub4S8 select-v2__value--enabled cont_-KgHbcqqpFOGBg2KCIprP select-v2__value--flush-left cont_-MOD91oJKncNXYVGwIK5p select-v2__value--flush-right"
              data-test="member-select-button"
              id="downshift-0-toggle-button"
              aria-haspopup="listbox"
              aria-expanded="false"
              aria-labelledby="downshift-0-label downshift-0-toggle-button"
              aria-hidden="false"
            >
              <span
                className="cont_-jwcM5_zQVrEDq8Y_1ot7 select-v2__value-display"
                data-test="value-display"
                id="Member-select-current-value"
              >
                All{" "}
              </span>
              <span aria-hidden="true">
                <svg
                  className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-eruDGVsNkUHIZvl3ak2G cont_-h_W2aK9H9msWvqPPYyFQ select-v2__toggle"
                  data-test="svg"
                  aria-label="caret down"
                  role="img"
                >
                  <title data-test="svg-title">caret down</title>
                  <use xlinkHref="#anatomy-caret-down" />
                </svg>
              </span>
            </button>
            <ul
              className="cont_-M1TEXBYkwFUP4st5ozvh select-v2__options"
              id="downshift-0-menu"
              role="listbox"
              aria-labelledby="downshift-0-label"
              tabIndex={-1}
              data-test="member-select-option-list"
            />
          </div>
          <div
            id="Claim_Type-select"
            className="cont_-N9KR1n0RF2JkoKJLHIHS select-v2 cont_-YGjIz1Nflfo8gMoF9yFL instant-filter__select select-v2--closed select-v2--enabled cont_-DcdX5FlnSEm2FkuYTXx0 select-v2--has-border cont_-GAxItQ2D3EspEN8bWAJn select-v2--use-native-select-mobile"
            data-test="claim_type-select"
          >
            <label
              tabIndex={-1}
              id="downshift-1-label"
              className="cont_-W4MAs4fmY6dxuoeYyFlf form-label cont_-IMXkw5CLTbb4noFSIyeA select-v2__label"
              data-test="claim_type-select-label"
              htmlFor="downshift-1-toggle-button"
            >
              Claim Type
            </label>
            <button
              className="cont_-_O34cw7eYfQ1NOc6rYLM select-v2__value black fw-normal select-v2__value--closed cont_-yMA3kYVl9ioy584Ub4S8 select-v2__value--enabled cont_-KgHbcqqpFOGBg2KCIprP select-v2__value--flush-left cont_-MOD91oJKncNXYVGwIK5p select-v2__value--flush-right"
              data-test="claim_type-select-button"
              id="downshift-1-toggle-button"
              aria-haspopup="listbox"
              aria-expanded="false"
              aria-labelledby="downshift-1-label downshift-1-toggle-button"
              aria-hidden="false"
            >
              <span
                className="cont_-jwcM5_zQVrEDq8Y_1ot7 select-v2__value-display"
                data-test="value-display"
                id="Claim_Type-select-current-value"
              >
                All{" "}
              </span>
              <span aria-hidden="true">
                <svg
                  className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-eruDGVsNkUHIZvl3ak2G cont_-h_W2aK9H9msWvqPPYyFQ select-v2__toggle"
                  data-test="svg"
                  aria-label="caret down"
                  role="img"
                >
                  <title data-test="svg-title">caret down</title>
                  <use xlinkHref="#anatomy-caret-down" />
                </svg>
              </span>
            </button>
            <ul
              className="cont_-M1TEXBYkwFUP4st5ozvh select-v2__options"
              id="downshift-1-menu"
              role="listbox"
              aria-labelledby="downshift-1-label"
              tabIndex={-1}
              data-test="claim_type-select-option-list"
            />
          </div>
          <div
            id="Date_Range-select"
            className="cont_-N9KR1n0RF2JkoKJLHIHS select-v2 cont_-YGjIz1Nflfo8gMoF9yFL instant-filter__select select-v2--closed select-v2--enabled cont_-DcdX5FlnSEm2FkuYTXx0 select-v2--has-border cont_-GAxItQ2D3EspEN8bWAJn select-v2--use-native-select-mobile"
            data-test="date_range-select"
          >
            <label
              tabIndex={-1}
              id="downshift-2-label"
              className="cont_-W4MAs4fmY6dxuoeYyFlf form-label cont_-IMXkw5CLTbb4noFSIyeA select-v2__label"
              data-test="date_range-select-label"
              htmlFor="downshift-2-toggle-button"
            >
              Date Range
            </label>
            <button
              className="cont_-_O34cw7eYfQ1NOc6rYLM select-v2__value black fw-normal select-v2__value--closed cont_-yMA3kYVl9ioy584Ub4S8 select-v2__value--enabled cont_-KgHbcqqpFOGBg2KCIprP select-v2__value--flush-left cont_-MOD91oJKncNXYVGwIK5p select-v2__value--flush-right"
              data-test="date_range-select-button"
              id="downshift-2-toggle-button"
              aria-haspopup="listbox"
              aria-expanded="false"
              aria-labelledby="downshift-2-label downshift-2-toggle-button"
              aria-hidden="false"
            >
              <span
                className="cont_-jwcM5_zQVrEDq8Y_1ot7 select-v2__value-display"
                data-test="value-display"
                id="Date_Range-select-current-value"
              >
                All (Last 2 years){" "}
              </span>
              <span aria-hidden="true">
                <svg
                  className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-eruDGVsNkUHIZvl3ak2G cont_-h_W2aK9H9msWvqPPYyFQ select-v2__toggle"
                  data-test="svg"
                  aria-label="caret down"
                  role="img"
                >
                  <title data-test="svg-title">caret down</title>
                  <use xlinkHref="#anatomy-caret-down" />
                </svg>
              </span>
            </button>
            <ul
              className="cont_-M1TEXBYkwFUP4st5ozvh select-v2__options"
              id="downshift-2-menu"
              role="listbox"
              aria-labelledby="downshift-2-label"
              tabIndex={-1}
              data-test="date_range-select-option-list"
            />
          </div>
          <div
            id="Provider__Facility_or_Rx_-select"
            className="cont_-N9KR1n0RF2JkoKJLHIHS select-v2 cont_-YGjIz1Nflfo8gMoF9yFL instant-filter__select select-v2--closed select-v2--enabled cont_-DcdX5FlnSEm2FkuYTXx0 select-v2--has-border cont_-GAxItQ2D3EspEN8bWAJn select-v2--use-native-select-mobile"
            data-test="provider__facility_or_rx_-select"
          >
            <label
              tabIndex={-1}
              id="downshift-3-label"
              className="cont_-W4MAs4fmY6dxuoeYyFlf form-label cont_-IMXkw5CLTbb4noFSIyeA select-v2__label"
              data-test="provider__facility_or_rx_-select-label"
              htmlFor="downshift-3-toggle-button"
            >
              Provider, Facility or Rx{" "}
            </label>
            <button
              className="cont_-_O34cw7eYfQ1NOc6rYLM select-v2__value black fw-normal select-v2__value--closed cont_-yMA3kYVl9ioy584Ub4S8 select-v2__value--enabled cont_-KgHbcqqpFOGBg2KCIprP select-v2__value--flush-left cont_-MOD91oJKncNXYVGwIK5p select-v2__value--flush-right"
              data-test="provider__facility_or_rx_-select-button"
              id="downshift-3-toggle-button"
              aria-haspopup="listbox"
              aria-expanded="false"
              aria-labelledby="downshift-3-label downshift-3-toggle-button"
              aria-hidden="false"
            >
              <span
                className="cont_-jwcM5_zQVrEDq8Y_1ot7 select-v2__value-display"
                data-test="value-display"
                id="Provider__Facility_or_Rx_-select-current-value"
              >
                All{" "}
              </span>
              <span aria-hidden="true">
                <svg
                  className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-eruDGVsNkUHIZvl3ak2G cont_-h_W2aK9H9msWvqPPYyFQ select-v2__toggle"
                  data-test="svg"
                  aria-label="caret down"
                  role="img"
                >
                  <title data-test="svg-title">caret down</title>
                  <use xlinkHref="#anatomy-caret-down" />
                </svg>
              </span>
            </button>
            <ul
              className="cont_-M1TEXBYkwFUP4st5ozvh select-v2__options"
              id="downshift-3-menu"
              role="listbox"
              aria-labelledby="downshift-3-label"
              tabIndex={-1}
              data-test="provider__facility_or_rx_-select-option-list"
            />
          </div>
          <div
            id="Claim_Status_-select"
            className="cont_-N9KR1n0RF2JkoKJLHIHS select-v2 cont_-YGjIz1Nflfo8gMoF9yFL instant-filter__select select-v2--closed select-v2--enabled cont_-DcdX5FlnSEm2FkuYTXx0 select-v2--has-border cont_-GAxItQ2D3EspEN8bWAJn select-v2--use-native-select-mobile"
            data-test="claim_status_-select"
          >
            <label
              tabIndex={-1}
              id="downshift-4-label"
              className="cont_-W4MAs4fmY6dxuoeYyFlf form-label cont_-IMXkw5CLTbb4noFSIyeA select-v2__label"
              data-test="claim_status_-select-label"
              htmlFor="downshift-4-toggle-button"
            >
              Claim Status{" "}
            </label>
            <button
              className="cont_-_O34cw7eYfQ1NOc6rYLM select-v2__value black fw-normal select-v2__value--closed cont_-yMA3kYVl9ioy584Ub4S8 select-v2__value--enabled cont_-KgHbcqqpFOGBg2KCIprP select-v2__value--flush-left cont_-MOD91oJKncNXYVGwIK5p select-v2__value--flush-right"
              data-test="claim_status_-select-button"
              id="downshift-4-toggle-button"
              aria-haspopup="listbox"
              aria-expanded="false"
              aria-labelledby="downshift-4-label downshift-4-toggle-button"
              aria-hidden="false"
            >
              <span
                className="cont_-jwcM5_zQVrEDq8Y_1ot7 select-v2__value-display"
                data-test="value-display"
                id="Claim_Status_-select-current-value"
              >
                All{" "}
              </span>
              <span aria-hidden="true">
                <svg
                  className="svg cont_-NpdKQ3JYfyiZwSiU_CTC cont_-eruDGVsNkUHIZvl3ak2G cont_-h_W2aK9H9msWvqPPYyFQ select-v2__toggle"
                  data-test="svg"
                  aria-label="caret down"
                  role="img"
                >
                  <title data-test="svg-title">caret down</title>
                  <use xlinkHref="#anatomy-caret-down" />
                </svg>
              </span>
            </button>
            <ul
              className="cont_-M1TEXBYkwFUP4st5ozvh select-v2__options"
              id="downshift-4-menu"
              role="listbox"
              aria-labelledby="downshift-4-label"
              tabIndex={-1}
              data-test="claim_status_-select-option-list"
            />
          </div>
        </div>
      </article></>
    )
}